<script>
  const socialIcons = [
    {
      name: 'fb',
      url: 'https://www.facebook.com/uniformhero',
    },
    {
      name: 'ig',
      url: 'https://www.instagram.com/uniform_hero/',
    },
    //   {
    //         name: "twitter",
    //         url: "https://twitter.com/uniformhero",
    //   },
    //   {
    //         name: "youtube",
    //         url: "https://www.youtube.com/channel/UC-lHJZR3Gqxm24_Vd_AJ5Yw",
    //   },
    {
      name: 'linkedin',
      url: 'https://www.linkedin.com/company/uniform-hero',
    },
    //   {
    //         name: "pinterest",
    //         url: "https://www.pinterest.com/uniformhero/",
    //   }
  ];
</script>

<div class="footer">
  <div class="copyright">
    Copyright &copy; {new Date().getFullYear()} Jupetar Pty Ltd T/A Uniform Hero. All rights reserved
  </div>
  <div class="abn_privacy">
    <div class="abn">
      ABN: <a href="https://www.abr.business.gov.au/ABN/View?id=15656816796" target="_external">15 656 816 796</a>
    </div>
    <div class="privacy"><a href="/privacy-policy">Privacy Policy</a></div>
    <div class="terms">
      <a href="/terms-conditions">Terms & Conditions</a>
    </div>
  </div>
  <div class="social">
    Follow us :
    {#each socialIcons as icon}
      <a href={icon.url}><img src="img/icons/{icon.name}.svg" alt={icon.name} /></a>
    {/each}
  </div>
</div>

<style>
  .footer {
    color: #e4e4e4;
    text-align: center;
    font-size: 1.3rem;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
    padding-left: 2rem;
    padding-right: 2rem;
    background-color: #1c2a5c;
    min-height: 50px;
    line-height: 3rem;
  }

  .footer a {
    color: #e4e4e4;
    text-decoration: none;
  }

  .abn_privacy {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .privacy {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .social {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .social a {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .social img {
    width: 30px;
    height: 30px;
    margin-top: 1rem;
  }

  @media screen and (max-width: 900px) {
    .footer {
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 700px) {
    .footer {
      grid-template-columns: 1fr;
    }

    .social img {
      width: 20px;
      height: 20px;
      margin-top: 1rem;
    }
  }
</style>
